import { render, staticRenderFns } from "./swiper-img.vue?vue&type=template&id=a2ba4004&scoped=true"
import script from "./swiper-img.vue?vue&type=script&lang=js"
export * from "./swiper-img.vue?vue&type=script&lang=js"
import style0 from "./swiper-img.vue?vue&type=style&index=0&id=a2ba4004&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ba4004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2ba4004')) {
      api.createRecord('a2ba4004', component.options)
    } else {
      api.reload('a2ba4004', component.options)
    }
    module.hot.accept("./swiper-img.vue?vue&type=template&id=a2ba4004&scoped=true", function () {
      api.rerender('a2ba4004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiper-img.vue"
export default component.exports